import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import { handleUnauthorized } from "../../utils/apiHelper";
import moment from "moment";

const ViewReceivedNotification = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("notification-info");

  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    fetchNotification();
    // eslint-disable-next-line
  }, [id]);

  const fetchNotification = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/viewNotification/received/${id}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to fetch notification");

      setNotification(data.notification);
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">

            {/* Error Alert */}
            {errorMessage && (
              <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />
            )}

            {/* HEADER WITH BACK BUTTON */}
         

            {/* TABS */}
            <ul className="nav border-gradient-tab nav-pills mb-20 d-inline-flex" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${
                    activeTab === "notification-info" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("notification-info")}
                  type="button"
                  role="tab"
                >
                  Notification Info
                </button>
              </li>
            </ul>

            {/* TAB CONTENT */}
            <div className="tab-content">

              {/* TAB: Notification Info */}
              <div
                className={`tab-pane fade ${
                  activeTab === "notification-info" ? "show active" : ""
                }`}
                role="tabpanel"
              >
                <div className="row">

                  {/* Title */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Title:</label>
                    <div>{notification?.title || "N/A"}</div>
                  </div>

                  {/* Message */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Message:</label>
                    <div>{notification?.message || "N/A"}</div>
                  </div>

                  {/* Notification Type */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Notification Type:</label>
                    <div className="text-capitalize">
                      {notification?.notificationType || "N/A"}
                    </div>
                  </div>

                  {/* Sent By */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Sent By:</label>
                    <div className="text-capitalize">
                      {notification?.sendBy || "N/A"}
                    </div>
                  </div>

                  {/* Sent To */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Sent To:</label>
                    <div className="text-capitalize">
                      {notification?.sendTo || "N/A"}
                    </div>
                  </div>

                  {/* Read Status */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Read Status:</label>
                    <div>{notification?.isRead === "1" ? "Read" : "Unread"}</div>
                  </div>

                  {/* Date */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Date:</label>
                    <div>
                      {notification?.createdAt
                        ? moment(notification.createdAt).format("DD-MM-YYYY, hh:mm A")
                        : "N/A"}
                    </div>
                  </div>

                  {/* Sender */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Sender:</label>
                    <div>
                      {notification?.sender
                        ? `${notification?.sender?.email || "N/A"}`
                        : "N/A"}
                    </div>
                  </div>

                  {/* Meta */}
                  {/* <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Meta:</label>
                    <div>
                      {notification?.meta ? JSON.stringify(notification.meta) : "N/A"}
                    </div>
                  </div> */}

                </div>
              </div>

            </div>

            

          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReceivedNotification;
